import { instance } from './baseApi';
import { ISetting } from '../redux/settings/settingsTypes';

export const settingsApi = {
  getSettings: (path: string) => instance.get(`v1/admin/settings?key=${path}`),

  updateSettings: (setting: Omit<ISetting, 'key'>, key: string) =>
    instance.put('v1/admin/settings', { ...setting, key }),
};
